import { Component, Vue, Prop } from "vue-property-decorator";
import PatientDetailAttending from "@/components/census/PatientDetailAttending";
import { Getter } from "vuex-class";
import { patientNamespace } from "@/store/modules/patient";
import { CaseState } from "@/store/types";
import AlertsIcon from "@/components/shared/AlertsIcon";
import { Patient } from "@/store/modules/patient/types";

@Component({
  components: { PatientDetailAttending, AlertsIcon }
})
export default class HandoffCard extends Vue {
  @Getter("caseState", patientNamespace)
  caseStates!: Array<CaseState>;

  @Prop(Object)
  data!: Patient;

  getAbbrev(caseStateIndex: number) {
    return this.caseStates[caseStateIndex].abbrev;
  }

  getColor(caseStateIndex: number) {
    const caseStates = this.$store.getters["patient/caseState"];
    if (caseStates && caseStates[caseStateIndex]) {
      return caseStates[caseStateIndex].color;
    }
    return null;
  }
}
